"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
exports.isCallMessageDetails = (details) => details !== null && details.type === "call";
var CallStatus;
(function (CallStatus) {
    CallStatus["NEW"] = "NEW";
    CallStatus["CANCELLED"] = "CANCELLED";
    CallStatus["DECLINED"] = "DECLINED";
    CallStatus["ACCEPTED"] = "ACCEPTED";
    CallStatus["ENDED"] = "ENDED";
})(CallStatus = exports.CallStatus || (exports.CallStatus = {}));
class CallsProvider extends DataProvider_1.default {
    get fragments() {
        return {
            Call: () => `
        ... on Call {
          id
          callerId
          caller {
            ${this.getFragment("UserPublicData")}
          }
          receiverId
          receiver {
            ${this.getFragment("UserPublicData")}
          }
          createTime
          startTime
          endTime
          status
        }
      `,
            CallCreateResponse: () => `
        ... on CallCreateResponse {
          call {
            ${this.getFragment("Call")}
          }
          connection {
            ${this.getFragment("WebRTCConnection")}
          }
        }
      `,
        };
    }
    create({ receiverId }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("callCreate", { receiverId }, this.getFragment("CallCreateResponse"));
        });
    }
    accept({ callId }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("callAccept", { callId }, this.getFragment("Call"));
        });
    }
    end({ callId }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("callEnd", { callId }, this.getFragment("Call"));
        });
    }
    subscribeIncomingCall(onData, onError) {
        return this.api.subscribe({
            query: graphql_tag_1.default `
        subscription IncomingCall {
          incomingCall {
            ${this.getFragment("CallCreateResponse")}
          }
        }
      `,
        }, data => {
            onData(data.incomingCall);
        }, onError);
    }
    subscribeCallStatusUpdated(onData, onError) {
        return this.api.subscribe({
            query: graphql_tag_1.default `
        subscription CallStatusUpdated {
          callStatusUpdated {
            ${this.getFragment("Call")}
          }
        }
      `,
        }, data => {
            onData(data.callStatusUpdated);
        }, onError);
    }
    find({ data }) {
        return this.query("callFind", { data }, this.getPageableFragment("Call"));
    }
    findActive() {
        return this.query("activeCallFind", {}, this.getFragment("CallCreateResponse"));
    }
}
exports.CallsProvider = CallsProvider;
//# sourceMappingURL=CallsProvider.js.map